import dispatcher from '../dispatcher';
import routerStore from '../router/router.store';
import * as utils from '../utils';
import underlineDecorator from '../decor/underline.decorator';

var elementProto = Object.create(HTMLAnchorElement.prototype);
var ie = utils.getIEVersion();

function _cleanHref(href) {
	if (!href) {
		return undefined;
	}
	return href.split('#')[0].split('?')[0];
}

var _handleClick = function(e) {
	var href = routerStore.getData().page.href;
	var pw	= document.querySelector('.page-wrapper');
	var top = pw.getBoundingClientRect().top;
	var self = this;
	var rect;
	var coordinates;
	var target = this.getAttribute('data-target');
	var copyElement;

	if (target) {
		target = this.querySelector(target);
		if (!target) target = this;
	} else {
		target = this;
	}

	if (ie > -1 && ie < 11) {
		return;
	}

	e.preventDefault();
	if (href === this.href) return;

	rect = target.getBoundingClientRect();

	dispatcher.dispatch({
		type: 'router:route',
		href: self.href,
		transitionData: {
			animation: self._transitionType,
			url: href,
			hash: self.href.split('#')[1] || null,
			element: target,
			copyElement: copyElement,
			originalElement: self
		}
	});

	if (this.classList.contains('arr-back') || (this.dataset.sc === "false")) return;

	dispatcher.dispatch({
		type: 'router:route-back',
		top: utils.offset(this).top
	})
}

var _handleMouseenter = function() {
	var parent = this.closest('.link-group');
	var elements;
	if (this.classList.contains('active') || !parent) return;

	elements = parent.querySelectorAll('a[is="inner-link"]');
	Array.prototype.forEach.call(elements, function(el) {
		el.classList.add('hover');
	});
}

var _handleMouseleave = function() {
	var parent = this.closest('.link-group');
	var elements;
	if (!parent) return;

	elements = parent.querySelectorAll('a[is="inner-link"]');
	Array.prototype.forEach.call(elements, function(el) {
		el.classList.remove('hover');
	});
}

var _handleRouterStore = function() {
	var href = routerStore.getData().page.href;

	if (_cleanHref(href) === _cleanHref(this.href)) {
		this.classList.add('active');
		this._active = true;
		this.setAttribute('aria-current', 'page');
		if (this._hoverParent) {
			this.parentNode.classList.add('active');
		}
	} else {
		this.classList.remove('active');
		this._active = false;
		this.removeAttribute('aria-current');
		if (this._hoverParent) {
			this.parentNode.classList.remove('active');
		}
	}
}

elementProto.createdCallback = function() {
	this.handleClick = _handleClick.bind(this);
	this.handleMouseenter = _handleMouseenter.bind(this);
	this.handleMouseleave = _handleMouseleave.bind(this);
	this.handleRouterStore = _handleRouterStore.bind(this);
}
elementProto.attachedCallback = function() {
	this._transitionType = this.getAttribute('data-animation') || 'basic';
	this._outer = this.getAttribute('data-outer');

	this.handleRouterStore();

	if (!this._outer) {
		this.addEventListener('click', this.handleClick);
	}

	this.addEventListener('mouseenter', this.handleMouseenter);
	this.addEventListener('mouseleave', this.handleMouseleave);

	routerStore.subscribe(this.handleRouterStore);

	if (this.classList.contains('underline')) {
		underlineDecorator.attach(this);
	}
}
elementProto.detachedCallback = function() {
	routerStore.unsubscribe(this.handleRouterStore);

	if (this.classList.contains('underline')) {
		underlineDecorator.detach(this);
	}
}

document.registerElement('inner-link', {
	extends: 'a',
	prototype: elementProto
});

export default elementProto;